enum LeadAlertTypesEnum {
    PrivateListing = 'Private Listing',
    Level2FileAccess = 'Level 2 File Access'
}

export default LeadAlertTypesEnum;
